module.exports = __webpack_public_path__ + "img/A8.2c18946b.png";